const assetImages = {
    logo: require('~/assets/images/tiktok.svg').default,
    error: require('~/assets/images/404.png'),
    error2: require('~/assets/images/404_2.png'),
    avartar: require('~/assets/images/avatar.jpg'),
    thumb_avatar: require('~/assets/images/thumb_img.jpg'),
    thumb_avatar_2: require('~/assets/images/thumb_img_2.jpeg'),
    noImage: require('~/assets/images/no-image.png'),
    facebook: require('~/assets/images/facebook.svg').default,
    google: require('~/assets/images/google.svg').default,
    twitter: require('~/assets/images/twitter.svg').default,
    line: require('~/assets/images/LINE.svg').default,
    kakaotalk: require('~/assets/images/kakaotalk.svg').default,
    apple: require('~/assets/images/apple.svg').default,
    instagram: require('~/assets/images/instagram.svg').default,
    whatsapp: require('~/assets/images/whatsapp.svg').default,
    linkedin: require('~/assets/images/linkedin.svg').default,
    telegram: require('~/assets/images/telegram.svg').default,
    pinterest: require('~/assets/images/pinterest.svg').default
};

export default assetImages;
